import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    ActivityLogClient,
    ActivityLogView,
    ActivityLogViewPaginatedResultDto,
    SearchActivityLogsParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ActivityLogService {
    constructor(private readonly client: ActivityLogClient) {}

    async search(parameters: SearchActivityLogsParameters): Promise<ActivityLogViewPaginatedResultDto> {
        return await lastValueFrom(this.client.activityLogSearch(parameters));
    }

    async getById(id: number): Promise<ActivityLogView> {
        return await lastValueFrom(this.client.activityLogGetById(id));
    }
}
